import { render } from "./SortOptions.vue?vue&type=template&id=2a33fe21&scoped=true"
import script from "./SortOptions.vue?vue&type=script&lang=js"
export * from "./SortOptions.vue?vue&type=script&lang=js"

import "./SortOptions.vue?vue&type=style&index=0&id=2a33fe21&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a33fe21"]])

export default __exports__